import React from 'react';

export default props => (
    <svg
        width="20px"
        height="26px"
        viewBox="0 0 20 26"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g
                transform="translate(-138.000000, -954.000000)"
                stroke="currentColor"
                strokeWidth="2"
            >
                <g id="list-button" transform="translate(31.000000, 947.000000)">
                    <g id="hand" transform="translate(108.000000, 8.000000)">
                        <path
                            d="M0.604451148,5.66776114 L0.780912174,5.49983116 C1.22077835,5.08123042 1.90948508,5.07413467 2.35788265,5.48358364 L2.37567571,5.49983116 C2.57391713,5.68085298 2.88137073,5.66689374 3.06239255,5.46865232 C3.1441804,5.37908444 3.18952707,5.26217494 3.18952707,5.14088332 L3.18952707,4.04260179 C3.18952707,3.48366213 3.49396808,2.96909356 3.9838683,2.70000004 L4.02632334,2.67668024 C4.49240202,2.42067147 5.05896592,2.42953581 5.51680751,2.70000004 C5.74961132,2.83752599 6.0498229,2.76028803 6.18734885,2.52748423 C6.23190293,2.45206313 6.2554055,2.36606947 6.2554055,2.27847147 L6.2554055,1.21609569 C6.2554055,0.727440047 6.59156793,0.302985213 7.06722984,0.1910473 L7.42170663,0.107627979 C7.72228638,0.0368922966 8.03538453,0.0387040201 8.33512556,0.112913423 L8.73605106,0.212173913 C9.13921135,0.311987692 9.4223819,0.673814561 9.4223819,1.08914698 C9.4223819,1.36938783 9.649562,1.59656793 9.92980285,1.59656793 C9.98503777,1.59656793 10.0399021,1.58754949 10.0922307,1.56986854 L10.4307847,1.45547676 C10.8475336,1.31466419 11.2996975,1.31920942 11.7135315,1.46837115 L11.8487333,1.51710306 C12.3133509,1.68456915 12.6230576,2.12540981 12.6230576,2.61928678 L12.6230576,12.2043785 C12.6230576,12.5626173 12.9134675,12.8530272 13.2717063,12.8530272 C13.4437386,12.8530272 13.6087249,12.7846876 13.7303701,12.6630424 L15.2073628,11.1860498 C15.6730899,10.7203227 16.3644111,10.5625021 16.9861067,10.7799833 L17.1737761,10.8456337 C17.6898144,11.0261539 18.0768294,11.4592573 18.1983955,11.9922721 C18.3199691,12.5253192 18.1591282,13.0834398 17.7725281,13.4700399 L14.180458,17.06211 C13.8299901,17.4125895 13.5872356,17.8561161 13.4809193,18.340224 C12.6756135,22.0071588 10.4163488,23.8406262 6.7031251,23.8406262 C2.80005505,23.8406262 0.571650295,21.8148864 0.0179108466,17.7634068 C0.00598864042,17.6760749 1.07942749e-17,17.5880348 0,17.4998929 L0,7.07740555 C-1.20462269e-15,6.54458751 0.218477447,6.03507485 0.604451148,5.66776114 Z"
                            id="Path-2"
                        ></path>
                        <path
                            d="M5.32918082,18.4339107 C5.88827358,17.142003 6.46504724,16.2985063 7.05950179,15.9034208 C7.65395635,15.5083354 8.67308644,15.2897543 10.116892,15.2476776"
                            id="Path-3"
                            strokeLinecap="round"
                        ></path>
                        <line
                            x1="3.18440789"
                            y1="5.16207778"
                            x2="3.18440789"
                            y2="12.4910475"
                            id="Path-4"
                            strokeLinecap="round"
                        ></line>
                        <line
                            x1="6.21271124"
                            y1="2.37288855"
                            x2="6.20929063"
                            y2="11.4838684"
                            id="Path-4"
                            strokeLinecap="round"
                        ></line>
                        <line
                            x1="9.51910909"
                            y1="1.59451016"
                            x2="9.51568849"
                            y2="10.70549"
                            id="Path-4"
                            strokeLinecap="round"
                        ></line>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);
